import { IconButton } from '@nrg/design-system';
import { type ComponentProps, type ReactNode, useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LuEye, LuEyeOff } from 'react-icons/lu';
import FormField from './FormField';

type InputCommonProps = Omit<ComponentProps<'input'>, 'id' | 'type' | 'size'>;

export interface PasswordFieldProps extends InputCommonProps {
  label: ReactNode;
  error?: string | null | undefined;
  hint?: ReactNode;
}

export default function PasswordField({ label, error, hint, ...rest }: PasswordFieldProps) {
  const { t } = useTranslation('auth');
  const [visible, setVisible] = useState(false);
  const reactId = useId();
  const buttonId = `pw-toggle-${reactId}`;

  return (
    <FormField
      label={label}
      error={error}
      hint={hint}
      type={visible ? 'text' : 'password'}
      iconRight={
        <IconButton
          id={buttonId}
          type="button"
          variant="ghost"
          size="sm"
          label={visible ? t('common.hide_password') : t('common.show_password')}
          onClick={() => setVisible((v) => !v)}
        >
          {visible ? <LuEyeOff aria-hidden /> : <LuEye aria-hidden />}
        </IconButton>
      }
      {...rest}
    />
  );
}
